import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import { Provider } from 'react-redux'
import configureStore from './store'
// import initReactFastclick from 'react-fastclick'
import { unregister } from './registerServiceWorker'

import { initRoutine } from './utils'

// initReactFastclick()

const store = configureStore({})

initRoutine(store)

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
)

// registerServiceWorker()
unregister()



// WEBPACK FOOTER //
// ./src/index.js